import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { PaywallAlertComponent } from '@modules/paywall/paywall-alert/paywall-alert.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RedirectionService } from '@services/redirection.service';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { SidebarService } from '../sidebar/sidebar.service';
import { PageTitleService } from './page-title.service';

@UntilDestroy()
@Component({
  templateUrl: './main-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SidebarService, PageTitleService, RedirectionService],
  imports: [CommonModule, SidebarComponent, HeaderComponent, PaywallAlertComponent, RouterModule, TranslocoDirective],
})
export class MainLayoutComponent implements OnInit {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  readonly sidebarService = inject(SidebarService);

  ngOnInit(): void {
    this.breakpointObserver.observe('(min-width: 768px) and (max-width: 1023px)').subscribe((result) => {
      this.sidebarService.collapsed = result.matches;
      this.changeDetectorRef.detectChanges();
    });
  }
}
